import React from "react";
import { IGrid } from "../interfaces/IGrid";
import { Box, Grid } from "@mui/material";
import CmsContentReference from "./CmsContentReference";
import { PortableText } from "@portabletext/react";
import CmsImage from "./CmsImage";
import CmsList from "./CmsList";

const CmsGrid : React.FC<IGrid> = ({rows}) => {
    const MAX_CELLS_XL = 12;
    const MAX_CELLS_LG = 12;
    const MAX_CELLS_MD = 6;
    const MAX_CELLS_SM = 3;
    const MAX_CELLS_XS = 1;

    const getCellCount = (maxCells: number, cellsOfRow: number) => {
        const cellWidth = Math.floor(12 / cellsOfRow);
        return cellsOfRow <= maxCells ? cellWidth : Math.floor(12/ maxCells);
    }

    const getMarginForCell = (margin?: ("none" | "small" | "medium" | "large")) => {
        if(!margin) {
            return '0';
        }
        switch(margin) {
            case "small":
                return '0.5em';
            case "medium":
                return '1em';
            case "large":
                return '1.5em';
            default:
                return '0';
        }
    }
    
    return <>
        {rows?.map((row, i) => <Grid key={`grid_row_${i}`} container>
            {row?.cells?.map((cell, c) => <Grid 
                key={`grid_cell_${i}_${c}_${cell.contentType}`} 
                item 
                xs={getCellCount(MAX_CELLS_XS, row?.cells?.length)}
                sm={getCellCount(MAX_CELLS_SM, row?.cells?.length)}
                md={getCellCount(MAX_CELLS_MD, row?.cells?.length)}
                lg={getCellCount(MAX_CELLS_LG, row?.cells?.length)}
                xl={getCellCount(MAX_CELLS_XL, row?.cells?.length)}
                >
                    <Box sx={{margin: getMarginForCell(cell?.padding)}}>
                {cell?.contentType === "richtext" && cell?.content && cell?.content?.map((c, ci) => <PortableText key={`richtext_${ci}`} value={c} />)}
                {cell?.contentType === "image" && <CmsImage {...cell?.image} />}
                {cell?.contentType === "list" && <CmsList {...cell?.list} />}
                {cell?.contentType === "contentRef" && cell?.contentRef && <CmsContentReference {...cell?.contentRef} />}
                    </Box>
                </Grid>)}
        </Grid>)}
    </>
}

export default CmsGrid;